import type { AppState } from "./types";
import { defaultMetricUnitsForLanguage } from "./metric-units";
import { defaultWeeklyGoalCategoriesForLanguage } from "./weekly-goal-categories";
import { BROWSER_STORAGE_KEYS } from "../browser-storage";

export const STORAGE_KEY = BROWSER_STORAGE_KEYS.workspace;

export const defaultState: AppState = {
  schemaVersion: 9,
  profile: {
    userId: "",
    onboardingCompleted: false,
    authMode: "signup",
    accountRole: "",
    fullName: "",
    email: "",
    password: "",
    role: "",
    interests: [],
    challengeAreas: [],
    hobbies: [],
    globalGoals: [],
    yearGoals: [],
    globalGoalIds: [],
    yearGoalIds: [],
    yearGoalLinks: {},
    globalGoalCompleted: {},
    yearGoalCompleted: {},
    globalGoalMetrics: {},
    yearGoalMetrics: {},
    systemNeeds: [],
    weeklyCommitment: "",
    motivation: "",
    hasPassword: false,
    authProviders: [],
    legal: {
      currentTermsVersion: "terms-v1.0",
      currentPrivacyVersion: "privacy-v1.0",
      termsAccepted: false,
      privacyAccepted: false,
      aiConsentStatus: "UNDECIDED",
    },
  },
  settings: {
    timezone: "Europe/Warsaw",
    language: "en",
    reflectionUnlockHour: 0,
    dayStartTime: "00:00",
    autoSuggestFocus: true,
    showCompletedByDefault: true,
    dailyGoalNotificationsEnabled: true,
    dailyGoalEndReminderMinutes: 5,
    notificationSoundEnabled: true,
    streakFreeWeekdays: [],
    streakFreeDateRanges: [],
    defaultMetricUnits: defaultMetricUnitsForLanguage("en"),
    customMetricUnits: [],
    metricUnits: defaultMetricUnitsForLanguage("en"),
    defaultWeeklyGoalCategories: defaultWeeklyGoalCategoriesForLanguage("en"),
    customWeeklyGoalCategories: [],
    weeklyGoalCategories: defaultWeeklyGoalCategoriesForLanguage("en"),
    customWeeklyGoalCategoryLimit: 10,
    aiConsentStatus: "UNDECIDED",
  },
  weeklyGoalCategories: [],
  monthlyGoals: [],
  weeklyGoals: [],
  dailyItems: [],
  dailyItemsByDate: {},
  completionHistory: {},
  ragSources: [],
  userFeedback: "",
  dismissedSuggestionIds: [],
  updatedAt: new Date().toISOString(),
};
